export const initialData = {
  init: false,
  fields: {
    FirmStrategyID: null,
    FirmID: 0,
    Title: '',
    Content: '',
    OwnershipStyle: '',
    CompanySizeID: null,
    InvestmentSize: '',
    Geography: '',
    IndustrySectors: '',
    TransactionTypes: '',
  },
  options: {
    CompanySizeID: [],
  },
};
